import { AxiosRequestConfig } from 'axios';
import { getApiEndpointUrl } from '../mocks/baseUrls';

export const handleNativeHttpRequestFetcher = (
  pathname: string,
  method: AxiosRequestConfig['method'],
  headers: any = {},
  options: any = {},
) =>
  fetch(getApiEndpointUrl(pathname), {
    method,
    headers: headers || {
      'Content-Type': 'application/json',
    },
    ...options,
  }).then(res => res.json());
